// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_rk-0";